// extracted by mini-css-extract-plugin
export default {"logo":"MarketplaceHeader-module_logo_e179f3"};